"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarGroupFlyoutContainerStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _menuTheme = require("../../menu/styled/menuTheme");
const AvatarGroupFlyoutContainerStyled = (0, _styled.default)("div")`
    box-shadow: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _menuTheme.menuTheme.boxShadow(themeMode);
}};

    display: flex;
    flex-direction: column;
    padding: ${_designTokens.space.space20};

    background-color: ${(0, _designTokensReact.color)("color--background--surfaces--work")};

    border-radius: ${_designTokens.border.radius20};

    overflow-y: auto;

    isolation: isolate;
`;
exports.AvatarGroupFlyoutContainerStyled = AvatarGroupFlyoutContainerStyled;
//# sourceMappingURL=AvatarGroupFlyoutContainerStyled.js.map